import axios from "axios";
import globalValues from "./globalValues";
import { generateToken, generateUserToken } from "./TokenService";
export const customerRegister = async (data: any) => {
  try {
    const token = await generateToken();
    if (token) {
      return new Promise(async (resolve, reject) => {
        let headers = {
          Authorization: `Bearer ${token}`,
          "Access-Control-Allow-Origin": "*",
        };
        let url = `${globalValues.baseURLS.REACT_APP_RESERVATION_BASEURL}/v1/witmeg-customer-management`;
        await axios({
          method: "POST",
          url: url,
          headers,
          data,
        })
          .then((response) => {
            resolve(response.data.Result);
          })
          .catch((error) => {
            reject(error);
          });
      });
    }
  } catch (error) {
    console.error("Error In Customer Registration", error);
  }
};
export const verifyCustomerEmail = async (email: string) => {
  try {
    const token = await generateToken();
    if (token) {
      return new Promise(async (resolve, reject) => {
        let headers = {
          Authorization: `Bearer ${token}`,
          "Access-Control-Allow-Origin": "*",
        };
        let url = `${globalValues.baseURLS.REACT_APP_RESERVATION_BASEURL}/v1/witmeg-customer-management/verify?email=${email}`;
        await axios({
          method: "GET",
          url: url,
          headers,
        })
          .then((response) => {
            resolve(response.data.Result);
          })
          .catch((error) => {
            reject(error);
          });
      });
    }
  } catch (error) {
    console.error("Error In Verify Customer Email", error);
  }
};
export const verifyCustomerPhoneNumber = async (phoneNumber: string) => {
  try {
    const token = await generateToken();
    if (token) {
      return new Promise(async (resolve, reject) => {
        let headers = {
          Authorization: `Bearer ${token}`,
          "Access-Control-Allow-Origin": "*",
        };
        let url = `${globalValues.baseURLS.REACT_APP_RESERVATION_BASEURL}/v1/witmeg-customer-management/verify?phonenumber=${phoneNumber}`;
        await axios({
          method: "GET",
          url: url,
          headers,
        })
          .then((response) => {
            resolve(response.data.Result);
          })
          .catch((error) => {
            reject(error);
          });
      });
    }
  } catch (error) {
    console.error("Error In Verify Customer Phone Number", error);
  }
};
export const sendOTPtoPhone = async (phoneNumber: string) => {
  try {
    const token = await generateToken();
    if (token) {
      return new Promise(async (resolve, reject) => {
        let headers = {
          Authorization: `Bearer ${token}`,
          "Access-Control-Allow-Origin": "*",
        };
        let url = `${globalValues.baseURLS.REACT_APP_RESERVATION_BASEURL}/v1/witmeg-customer-management/send-otp?phonenumber=${phoneNumber}`;
        await axios({
          method: "GET",
          url: url,
          headers,
        })
          .then((response) => {
            resolve(response.data.Result);
          })
          .catch((error) => {
            reject(error);
          });
      });
    }
  } catch (error) {
    console.error("Error In Send OTP to Phone", error);
  }
};
export const sendOTPtoEmail = async (email: string) => {
  try {
    const token = await generateToken();
    if (token) {
      return new Promise(async (resolve, reject) => {
        let headers = {
          Authorization: `Bearer ${token}`,
          "Access-Control-Allow-Origin": "*",
        };
        let url = `${globalValues.baseURLS.REACT_APP_RESERVATION_BASEURL}/v1/witmeg-customer-management/send-otp?email=${email}`;
        await axios({
          method: "GET",
          url: url,
          headers,
        })
          .then((response) => {
            resolve(response.data.Result);
          })
          .catch((error) => {
            reject(error);
          });
      });
    }
  } catch (error) {
    console.error("Error In Send OTP to Email", error);
  }
};
export const OTPVerification = async (data: any) => {
  try {
    const token = await generateUserToken();
    if (token) {
      return new Promise(async (resolve, reject) => {
        let headers = {
          Authorization: `Bearer ${token}`,
          "Access-Control-Allow-Origin": "*",
        };
        let url = `${globalValues.baseURLS.REACT_APP_USERSERVICE_URL}/v1/witmeg/otp/verify`;
        await axios({
          method: "POST",
          url: url,
          headers,
          data,
        })
          .then((response) => {
            resolve(response.data.Result);
          })
          .catch((error) => {
            reject(error);
          });
      });
    }
  } catch (error) {
    console.error("Error In OTP verification", error);
  }
};
export const getCustomerEmail = async (email: string) => {
  try {
    const token = await generateToken();
    if (token) {
      return new Promise(async (resolve, reject) => {
        let headers = {
          Authorization: `Bearer ${token}`,
          "Access-Control-Allow-Origin": "*",
        };
        let url = `${globalValues.baseURLS.REACT_APP_RESERVATION_BASEURL}/v1/witmeg-customer-management?email=${email}`;
        await axios({
          method: "GET",
          url: url,
          headers,
        })
          .then((response) => {
            resolve(response.data.Result);
          })
          .catch((error) => {
            reject(error);
          });
      });
    }
  } catch (error) {
    console.error("Error In Get Customer Email", error);
  }
};
export const getCustomerPhoneNumber = async (phoneNumber: string) => {
  try {
    const token = await generateToken();
    if (token) {
      return new Promise(async (resolve, reject) => {
        let headers = {
          Authorization: `Bearer ${token}`,
          "Access-Control-Allow-Origin": "*",
        };
        let url = `${globalValues.baseURLS.REACT_APP_RESERVATION_BASEURL}/v1/witmeg-customer-management?phonenumber=${phoneNumber}`;
        await axios({
          method: "GET",
          url: url,
          headers,
        })
          .then((response) => {
            resolve(response.data.Result);
          })
          .catch((error) => {
            reject(error);
          });
      });
    }
  } catch (error) {
    console.error("Error In Verify Customer Phone Number", error);
  }
};
export const getPrivacyPolicy = async () => {
  try {
    const token = await generateToken();
    if (token) {
      return new Promise(async (resolve, reject) => {
        let headers = {
          Authorization: `Bearer ${token}`,
          "Access-Control-Allow-Origin": "*",
        };
        let url = `${globalValues.baseURLS.REACT_APP_RESERVATION_BASEURL}/v1/privacy-policy/customer_registration`;
        await axios({
          method: "GET",
          url: url,
          headers,
        })
          .then((response) => {
            resolve(response.data.Result);
          })
          .catch((error) => {
            reject(error);
          });
      });
    }
  } catch (error) {
    console.error("Error In Customer Registration", error);
  }
};
